import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const filtersDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'filters-directory-redirect',
	path: '/ManageFilters.jspa',
};
